// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Laos */
const LA = /^(?:(?:20(?:[23579]\d|8[78])|30[24]\d)\d{6}|30\d{7})$/;

export default LA;
